import { z } from 'my-zod'

export const additionalMediaSchema = z.object({
  mediaType: z.string(),
  mediaTitle: z.string(),
  mediaRevisionNumber: z.string().optional(),
  mediaSourceUri: z.string().url(),
  mediaExtension: z.string(),
  mediaCultureCode: z.string(),
  mediaNumber: z.string(),
  bulletinNumber: z.string().optional()
})

export const modelMediaSchema = z.object({
  modelNumber: z.string(),
  modelYear: z.string(),
  modelDescription: z.string(),
  productLineCode: z.string(),
  engine: z.object({
    generalEngineDescription: z.string(),
    displacementMeasure: z.object({
      unitCode: z.string(),
      value: z.number()
    })
  }),
  weightMeasure: z.object({
    unitCode: z.string(),
    value: z.number()
  }),
  marketingName: z.string(),
  productSegment: z.string(),
  modelSubSegment: z.string(),
  modelSuperSegment: z.string(),
  isHomologatedEu: z.boolean(),
  isModelSubSegmentMatch: z.boolean(),
  euCertificationNumber: z.string().optional(),
  brand: z.string(),
  serviceBrand: z.string(),
  additionalMedia: z.array(additionalMediaSchema)
})

export type modelMediaSchema = z.infer<typeof modelMediaSchema>
